import { registerModule } from '@sas-dvr/ltjs-commons/ltjsEnvironment';
import VAViewerPackage from './VAViewerPackage';
import '@sas-dvr/ltjs-transport/lib';
import '@sas-dvr/ltjs-bird/lib';
registerModule('vav', [VAViewerPackage]);
